<template>
    <div class="self-card-add">
        <!--  提交和查看历史记录按钮  -->
        <div class="booking-header">
            <div @click="goSelfCardHistory()">历史记录</div>
            <div class="booking-submit" @click="submit()">完成</div>
        </div>
        <!--  分割线  -->
        <div class="booking-division" />
        <div class="booking-form">
            <van-form ref="cardsForm">
                <!-- 渠道 -->
                <van-field
                    readonly
                    clickable
                    name="channel_name"
                    :value="channelCheckedText"
                    label="渠道:"
                    placeholder="请选择渠道"
                    required
                    @click="showChannelPicker = true"
                    :rules="[{ required: true, message: '请选择渠道' }]"
                    right-icon="arrow"
                    :disabled="channelList.length === 0"
                />
                <van-popup
                    v-model="showChannelPicker"
                    position="bottom"
                >
                    <div class="booking-home-search">
                        <div class="booking-home-search-header">
                            <div @click="showChannelPicker = false">取消</div>
                            <div class="booking-submit" @click="onChannelConfirm">完成</div>
                        </div>
                        <div class="booking-division" />
                        <form action="/">
                            <van-search
                                v-model="searchForm.channel"
                                placeholder="请输入搜索关键词"
                                show-action
                                @search="onChannelSearch"
                            >
                                <template #action>
                                    <div @click="onChannelSearch(searchForm.channel)">搜索</div>
                                </template>
                            </van-search>
                        </form>
                        <div class="booking-division" />
                        <div class="booking-home-search-list">
                            <van-checkbox-group v-model="channelCheckedList">
                                <van-cell-group name="channel">
                                    <van-cell
                                        v-for="(channel, index) in channelList"
                                        clickable
                                        :key="channel.id"
                                        :title="channel.channel_name"
                                        @click="channelChecked(index)"
                                    >
                                        <template #right-icon>
                                            <van-checkbox
                                                shape="square"
                                                :name="channel"
                                                ref="checkboxes"
                                                checked-color="#DA0032"
                                            />
                                        </template>
                                    </van-cell>
                                </van-cell-group>
                            </van-checkbox-group>
                        </div>
                    </div>
                </van-popup>
                <!-- 是否实体卡 -->
                <van-field
                    name="is_entity"
                    label="是否实体卡:"
                    required
                    :rules="[{ required: true, message: '请选择是否实体卡' }]"
                >
                    <template #input>
                        <van-radio-group
                            checked-color="#DA0032"
                            v-model="cardsForm.is_entity"
                            direction="horizontal"
                            @change="onEntityChange"
                        >
                            <van-radio name="1">是</van-radio>
                            <van-radio name="0">否</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <!-- 卡版本 -->
                <van-field
                    readonly
                    clickable
                    name="card_version"
                    right-icon="arrow"
                    label="卡版本:"
                    placeholder="请选择卡版本"
                    required
                    :value="cardsForm.card_version_name"
                    :rules="[{ required: true, message: '请选择卡版本' }]"
                    @click="openCardVersion()"
                />
                <van-popup v-model="showCardVersionPicker" position="bottom">
                    <!-- 卡版本列表从 enums.js mixin selfCardEnum card_version 获取 -->
                    <van-picker
                        show-toolbar
                        value-key="value"
                        :columns="cardVersionList"
                        @confirm="onCardVersionConfirm"
                        @cancel="showCardVersionPicker = false"
                    />
                </van-popup>
                <!-- 卡类型 -->
                <van-field
                    readonly
                    clickable
                    name="card_type_name"
                    right-icon="arrow"
                    label="卡类型:"
                    placeholder="请选择卡类型"
                    required
                    :value="cardsForm.card_type_name"
                    :rules="[{ required: true, message: '请选择卡类型' }]"
                    @click="openCardType()"
                />
                <van-popup v-model="showCardTypePicker" position="bottom">
                    <van-picker
                        show-toolbar
                        value-key="card_name"
                        :columns="cardTypeList"
                        @confirm="onCardTypeConfirm"
                        @cancel="showCardTypePicker = false"
                    />
                </van-popup>
                <!-- 服务 -->
                <van-field label="服务:">
                    <template #input>
                        <div v-html="serviceNames"></div>
                    </template>
                </van-field>
                <!-- 单价 -->
                <van-field label="单价:">
                    <template #input>
                        {{ unitPrice }} 元
                    </template>
                </van-field>
                <!-- 每个渠道的开卡数量 -->
                <div class="cards-table-section">
                    <div class="cards-table-text">请填写每个渠道的开卡数量</div>
                    <div class="cards-table">
                        <div class="cards-table-row">
                            <div class="cards-table-column column2">渠道名称</div>
                            <div class="cards-table-column column2">数量*（张）</div>
                        </div>
                        <div class="cards-table-row" v-if="channelCheckedList.length === 0">
                            <div class="cards-table-column" style="width: 100%">请先选择"渠道"</div>
                        </div>
                        <div
                            class="cards-table-row"
                            v-for="(channel, index) in channelCheckedList"
                            :key="channel.id"
                            v-else
                        >
                            <div class="cards-table-column column2">
                                {{ channel.channel_name }}
                            </div>
                            <div class="cards-table-column column2">
                                <van-field
                                    v-model="channelCheckedList[index].count"
                                    name="input"
                                    type="digit"
                                    input-align="center"
                                    placeholder="请输入开卡数量"
                                    @blur="forceUpdate"
                                    @input="value => onCountChange(value, index)"
                                    :rules="[{ required: true, message: '请输入开卡数量' }]"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 总数量 -->
                <van-field label="总数量:">
                    <template #input>
                        {{ amount }} 张
                    </template>
                </van-field>
                <!-- 总价 -->
                <van-field label="总价:">
                    <template #input>
                        {{ totalPrice }} 元
                    </template>
                </van-field>
                <!-- 是否支付 -->
                <van-field
                    name="pay_status"
                    label="是否支付:"
                    required
                    :rules="[{ required: true, message: '请选择是否支付' }]"
                >
                    <template #input>
                        <van-radio-group
                            checked-color="#DA0032"
                            v-model="cardsForm.pay_status"
                            direction="horizontal"
                        >
                            <van-radio
                                :key="key"
                                :name="key"
                                v-for="(value, key) in selfCardEnum.pay_status"
                            >{{ value }}</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>
                <!-- 选择"是"或者"部分支付"显示以下内容 -->
                <div class="pay-section" v-if="cardsForm.pay_status != '2'" style="border-bottom: solid 1px #ebedf0">
                    <!-- 支付时间 -->
                    <van-field
                        readonly
                        clickable
                        name="pay_time"
                        right-icon="arrow"
                        :value="cardsForm.pay_time"
                        label="支付时间:"
                        placeholder="请选择支付时间"
                        required
                        :rules="[{ required: true, message: '请选择支付时间' }]"
                        @click="openPicker('showPaymentCalendar')"
                    />
                    <van-calendar
                        :min-date="new Date('2020-01-01')"
                        :default-date="new Date()"
                        :lazy-render="true"
                        v-model="showPaymentCalendar"
                        @confirm="onCalendarConfirm($event, 'showPaymentCalendar', 'pay_time')"
                    />
                    <!-- 已支付金额 -->
                    <van-field
                        v-model="cardsForm.pay_money"
                        name="pay_money"
                        class="pay-money"
                        label="已支付金额:"
                        placeholder="请输入金额"
                        type="digit"
                        required
                        @blur="forceUpdate"
                        :rules="[{ required: true, message: '请输入已支付金额' }]"
                        :disabled="totalPrice === 0"
                        @input="onPayMoneyChange"
                    >
                        <template #button>
                            元
                        </template>
                    </van-field>
                    <!-- 未支付金额 -->
                    <van-field label="未支付金额:">
                        <template #input>
                            {{ notPayMoney }} 元
                        </template>
                    </van-field>
                    <!-- 支付方式 -->
                    <van-field
                        name="pay_type"
                        label="支付方式:"
                        required
                        :rules="[{ required: true, message: '请选择支付方式' }]"
                    >
                        <template #input>
                            <van-radio-group
                                v-model="cardsForm.pay_type"
                                direction="horizontal"
                                checked-color="#DA0032"
                            >
                                <van-radio
                                    :key="key"
                                    :name="key"
                                    v-for="(value, key) in selfCardEnum.pay_type"
                                >{{ value }}</van-radio>
                            </van-radio-group>
                        </template>
                    </van-field>
                </div>
                <!-- 采购时间 -->
                <van-field
                    readonly
                    clickable
                    name="purchase_time"
                    right-icon="arrow"
                    :value="cardsForm.purchase_time"
                    label="采购时间:"
                    placeholder="请选择采购时间"
                    required
                    :rules="[{ required: true, message: '请选择采购时间' }]"
                    @click="openPicker('showPurchaseCalendar')"
                />
                <van-calendar
                    :min-date="new Date('2020-01-01')"
                    :default-date="new Date()"
                    :lazy-render="true"
                    v-model="showPurchaseCalendar"
                    @confirm="onCalendarConfirm($event, 'showPurchaseCalendar', 'purchase_time')"
                />
                <!-- 开卡时间 -->
                <van-field
                    readonly
                    clickable
                    name="card_create_time"
                    right-icon="arrow"
                    :value="cardsForm.card_create_time"
                    label="开卡时间:"
                    placeholder="请选择开卡时间"
                    required
                    :rules="[{ required: true, message: '请选择开卡时间' }]"
                    @click="openPicker('showCardCreateCalendar')"
                />
                <van-calendar
                    :min-date="new Date()"
                    :default-date="new Date()"
                    :lazy-render="true"
                    v-model="showCardCreateCalendar"
                    @confirm="onCalendarConfirm($event, 'showCardCreateCalendar', 'card_create_time')"
                />
                <!-- 附件 -->
                <van-field
                    label="附件:"
                    required
                >
                    <template #input>
                        <!-- 图片选择，上传前判断格式，删除前做数据处理 -->
                        <van-uploader
                            multiple
                            upload-icon="plus"
                            accept=""
                            :max-count="10"
                            v-model="fileList"
                            :after-read="afterRead" />
                    </template>
                </van-field>
                <!-- 备注 -->
                <van-field
                    v-model="cardsForm.remark"
                    rows="2"
                    autosize
                    label="备注:"
                    type="textarea"
                    maxlength="200"
                    placeholder="请输入备注"
                />
            </van-form>
        </div>
    </div>
</template>
<script>
import { Toast, CellGroup, Cell } from "vant";
import moment from "moment";
import selfCardService from "@/apis/selfCard/index.js";
import mixins from "./mixins/index.js";
import enums from "./mixins/enums.js";
export default {
    mixins: [enums, mixins],
    components: {
        [CellGroup.name]: CellGroup,
        [Cell.name]: Cell,
    },
    data() {
        return {
            submiting: false,
            cardsForm: {
                channel_ids: '',
                channel_count: [],
                is_entity: '',
                card_version: '',
                card_type_id: '',
                pay_status: '1',
                pay_time: '',
                pay_type: '',
                pay_money: '',
                not_pay_money: '',
                purchase_time: '',
                card_create_time: '',
                file: {},
                remark: ''
            },
            // 渠道
            showChannelPicker: false,
            searchForm: {},
            channelList: [],
            channelCheckedList: [],
            channelCheckedText: '',
            // 卡版本
            showCardVersionPicker: false,
            cardVersionList: [],
            // 卡类型
            showCardTypePicker: false,
            cardTypeList: [],
            // 服务列表
            services: [],
            // 单价
            unitPrice: 0,
            // 总数量
            amount: 0,
            // 是否显示支付时间的日历
            showPaymentCalendar: false,
            // 是否显示采购时间的日历
            showPurchaseCalendar: false,
            // 是否显示开卡时间的日历
            showCardCreateCalendar: false,
            // 附件的文件数组
            fileList: [],
        };
    },
    computed: {
        serviceNames() {
            let text = ''
            if (this.services.length > 0) {
                this.services.forEach(service => {
                    text = text + service.service_name + '<br />'
                })
            } else {
                text = '请先选择"卡版本"和"卡类型"'
            }
            return text
        },
        totalPrice() {
            return this.unitPrice * this.amount
        },
        notPayMoney () {
            const notPayMoney = this.totalPrice - this.cardsForm.pay_money
            return isNaN(notPayMoney) || (notPayMoney < 0) ? 0 : notPayMoney
        }
    },
    watch: {
        channelCheckedList: {
            handler(newVal) {
                this.amount = 0
                newVal.forEach(channel => {
                    if (Number.isInteger(Number(channel.count))) {
                        this.amount = this.amount + Number(channel.count)
                    }
                })
            },
            deep: true
        },
        'cardsForm.card_version': {
            handler(newVal) {
                if (newVal == '') {
                    this.cardsForm.card_type_id = ''
                    this.cardsForm.card_type_name = ''
                    this.cardTypeList = []
                }
            }
        },
        'cardsForm.card_type_id': {
            handler(newVal) {
                if (newVal == '') {
                    this.services = []
                    this.unitPrice = 0
                }
            }
        }
    },
    async created() {
        this.getChannels();
    },
    methods: {
        // 获取所有的渠道
        getChannels(query = "") {
            const params = { keyword: query };
            selfCardService.getChannels(params).then((res) => {
                this.channelList = res;
                this.channelCheckedList = []
            });
        },
        // 选中和取消选中渠道
        channelChecked(index) {
            this.$refs.checkboxes[index].toggle();
        },
        // 查询渠道
        onChannelSearch(query) {
            this.getChannels(query);
        },
        // 选中渠道以后点击"完成"按钮
        onChannelConfirm() {
            if (this.channelCheckedList.length === 0) {
                this.channelCheckedText = ''
            } else {
                if (this.channelCheckedList.length > 1) {
                    this.channelCheckedText = this.channelCheckedList[0].channel_name + '...'
                } else {
                    this.channelCheckedText = this.channelCheckedList[0].channel_name
                }
                this.channelCheckedList.forEach((channel, index) => {
                    this.$set(this.channelCheckedList[index], 'count', '')
                })
            }
            this.showChannelPicker = false;
        },
        // 选择是否是实体卡
        onEntityChange() {
            // 是否是实体卡切换的时候重置卡卡版本相关数据
            this.cardsForm.card_version = ''
            this.cardsForm.card_version_name = ''
            this.cardVersionList = []
            this.getCardVersionList();
        },
        // 获取卡版本列表
        getCardVersionList() {
            const params = {
                keyword: '',
                is_entity: Number(this.cardsForm.is_entity)
            };
            selfCardService.getCardVersions(params).then((res) => {
                this.cardVersionList = res;
            })
        },
        // 点击卡版本并显示卡版本列表
        openCardVersion() {
            if (this.cardsForm.is_entity == '') {
                Toast('请先选择"是否是实体卡"');
                return false
            }
            if (this.cardVersionList.length == 0) {
                Toast('当前没有可选择的卡版本, 请切换"是否是实体卡"选项');
                return false
            }
            this.showCardVersionPicker = true
        },
        // 卡版本切换
        onCardVersionConfirm(item) {
            if (this.cardsForm.card_version != item.key) {
                this.cardsForm.card_version = item.key;
                this.cardsForm.card_version_name = item.value;
                // 卡版本切换的时候重置卡类型列表
                this.cardTypeList = []
                this.cardsForm.card_type_id = ''
                this.cardsForm.card_type_name = ''
                this.getCardTypeList();
            }
            this.showCardVersionPicker = false;
        },
        // 获取卡类型列表
        getCardTypeList() {
            const params = {
                card_version: Number(this.cardsForm.card_version),
                is_entity: Number(this.cardsForm.is_entity)
            };
            selfCardService.getCardTypes(params).then((res) => {
                this.cardTypeList = res;
            })
        },
        // 点击卡类型并显示卡类型列表
        openCardType() {
            if (this.cardsForm.card_version == '') {
                Toast('请先选择"卡版本"');
                return false
            }
            if (this.cardTypeList.length == 0) {
                Toast('当前没有可选择的卡类型, 请切换"是否是实体卡"选项');
                return false
            }
            this.showCardTypePicker = true
        },
        // 卡类型切换
        onCardTypeConfirm(item) {
            if (this.cardsForm.card_type_id != item.id) {
                this.cardsForm.card_type_id = item.id;
                this.cardsForm.card_type_name = item.card_name;
                // 卡类型切换的时候重置服务和单价
                this.getServicesList();
                this.getUnitPrice();
            }
            this.showCardTypePicker = false;
        },
        // 获取卡服务
        getServicesList() {
            const params = {
                card_version: Number(this.cardsForm.card_version),
                card_type_id: Number(this.cardsForm.card_type_id)
            };
            selfCardService.getServices(params).then((res) => {
                this.services = res
            });
        },
        // 获取服务单价
        getUnitPrice() {
            const params = {
                card_version: Number(this.cardsForm.card_version),
                card_type_id: Number(this.cardsForm.card_type_id)
            };
            selfCardService.getUnitPrice(params).then((res) => {
                this.unitPrice = res.price
            });
        },
        // 当输入卡数量的时候进行数据校验
        onCountChange(value, index) {
            if (Number(value) === 0) {
                Toast("开卡数量不能为0张");
                this.channelCheckedList[index].count = ''
            }
        },
        // 当输入支付金额的时候进行数据校验
        onPayMoneyChange(value) {
            if (Number(value) === 0) {
                Toast("已支付金额不能为0元");
                this.cardsForm.pay_money = ''
            } else if (Number(value) > this.totalPrice) {
                Toast("已支付金额不能大于总价");
                this.cardsForm.pay_money = ''
            }
        },
        // 提交表单
        async submit() {
            if (this.submiting) {
                Toast("提交中，请勿重复点击");
                return false;
            }
            let errMsg = "";
            if (this.channelCheckedList.length === 0) {
                errMsg = '请选择渠道'
            } else if (this.cardsForm.is_entity == '') {
                errMsg = '请选择是否实体卡'
            } else if (this.cardsForm.card_version == '') {
                errMsg = '请选择卡版本'
            } else if (this.cardsForm.card_type_id == '') {
                errMsg = '请选择卡类型'
            } else if (this.channelCheckedList.length > 0) {
                for (let item of this.channelCheckedList) {
                    console.log(item);
                    if (item.count == '' || item.count == 0) {
                        errMsg = '请输入每个渠道的开卡数量'
                        break;
                    }
                }
            }
            if (errMsg) {
                Toast(errMsg);
                return false;
            }
            if (this.cardsForm.pay_status == '') {
                errMsg = '请选择是否支付'
            } else {
                if (this.cardsForm.pay_status != '2') {
                    if (this.cardsForm.pay_time == '') {
                        errMsg = '请选择支付时间'
                    } else if (this.cardsForm.pay_money == '' || this.cardsForm.pay_money == 0) {
                        errMsg = '请输入已支付金额'
                    } else if (this.cardsForm.pay_type == '') {
                        errMsg = '请选择支付方式'
                    } 
                }
            }
            if (errMsg) {
                Toast(errMsg);
                return false;
            }
            if (this.cardsForm.purchase_time == '') {
                errMsg = '请选择采购时间'
            } else if (this.cardsForm.card_create_time == '') {
                errMsg = '请选择开卡时间'
            } else if (this.fileList.length === 0) {
                errMsg = '请上传附件'
            }
            if (errMsg) {
                Toast(errMsg);
                return false;
            }
            const channelCheckedIds = [];
            const channelCheckedNames = [];
            const channels = []
            this.channelCheckedList.forEach(item => {
                const channel = {
                    channel_id: item.id,
                    channel_name: item.channel_name,
                    count: Number(item.count)
                }
                channelCheckedIds.push(item.id)
                channelCheckedNames.push(item.channel_name)
                channels.push(channel)
                
            })
            const params = {
                channel_ids: channelCheckedIds.join(','),
                channel_names: channelCheckedNames.join(','),
                channel_count: channels,
                is_entity: Number(this.cardsForm.is_entity),
                card_version: Number(this.cardsForm.card_version),
                card_type_id: Number(this.cardsForm.card_type_id),
                pay_status: Number(this.cardsForm.pay_status),
                pay_time: this.cardsForm.pay_time,
                pay_type: Number(this.cardsForm.pay_type),
                pay_money: Number(this.cardsForm.pay_money),
                not_pay_money: Number(this.notPayMoney),
                purchase_time: this.cardsForm.purchase_time,
                card_create_time: this.cardsForm.card_create_time,
                file: {
                    file_list: this.convertFilesToUploadFormat(this.fileList)
                },
                remark: this.cardsForm.remark,
                submit_user_id: this.currentUserInfo.user_id,
                submit_user_name: this.currentUserInfo.user_name
            };
            // 提交自助卡服务请求
            this.submiting = true;
            selfCardService.recordEdit(params).then((res) => {
                this.submiting = false;
                // 生成卡 Excel 的时间有的时候时间会很长, 所以不能等待响应后在跳转页面
                selfCardService.createCardsExcel({ record_id: res })
                this.$router.push('/selfCard/success');
            }).finally(() => {
                this.submiting = false;
            });
        },
        // 跳转到历史记录页面
        goSelfCardHistory() {
             this.$router.push('/selfCard/list');
        },
        // 打开日历
        openPicker(key) {
            this[key] = true;
        },
        // 日历选中时间后把日期显示在Input上, 同时关闭日历
        onCalendarConfirm(date, key, type) {
            this.cardsForm[type] = moment(date).format("YYYY-MM-DD");
            this[key] = false;
        },
        // 上传附件
        async afterRead(file) {
            if(Array.isArray(file)) {
                file.forEach(async(item) => {
                    const url = await this.uploadFileOss(item)
                    if (url != false) {
                        item.url = url
                    }
                })
            } else {
                const url = await this.uploadFileOss(file)
                if (url != false) {
                    file.url = url
                }
            }
        },
    }
};
</script>
